import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { R } from '@/Resources.resx';
import { Log } from '@/shared/Log';

export function ClockValidatorApp(containerQuery: string, serverTime: string) {
    const elm = document.querySelector(containerQuery);
    const root = createRoot(elm);
    root.render(<ClockValidator serverTimeString={serverTime} />);
}

function isClientTimeOff(serverTimeString: string) {
    const serverTime = new Date(serverTimeString).getTime();
    const clientTime = new Date().getTime();
    const diffMs = Math.abs(serverTime - clientTime);
    const twoMinutesInMs = 1000 * 60 * 2;
    return diffMs >= twoMinutesInMs;
}

function ClockValidator({ serverTimeString }: { serverTimeString: string }) {
    const [showWarning, setShowWarning] = React.useState(false);

    React.useEffect(() => {
        if (isClientTimeOff(serverTimeString)) {
            // double check with the server, the bootstrapped value might be coming from a cached page
            const fetchData = async () => {
                const data = await fetch('/api/health/time');
                const serverTimeString = await data.json();
                setShowWarning(isClientTimeOff(serverTimeString));
            };
            fetchData().catch(Log.error);
        }
    }, [serverTimeString]);

    return (
        showWarning && (
            <div className="bg-secondary-red-extralight text-secondary-red-dark p-4 text-center">
                {R.ClockValidatorError}
            </div>
        )
    );
}
